import {Component} from "preact";
import PropTypes from "prop-types";
import {difference, intersection} from "lodash";
import useUserStore from "../../store/userStore";
import {Children} from "preact-compat";
import Preact from "react";

export class WithPermission extends Component {
    static propType = {
        requiredPermissions: PropTypes.arrayOf(PropTypes.string).isRequired,
        requiredRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
        inclusivePermission: PropTypes.bool,
        renderOtherWise: PropTypes.element,
    }
    constructor(props) {
        super(props);

        this.userPermissions = useUserStore.getState().user?.permissions;
        this.userRoles = useUserStore.getState().user?.roles;
    }
    checkPermissions() {
        const { requiredPermissions, inclusivePermission } = this.props;

        return inclusivePermission
            ? intersection(this.userPermissions, requiredPermissions).length
            : difference(requiredPermissions, this.userPermissions).length === 0;
    }
    checkRoles() {
        const { requiredRoles } = this.props;
        return intersection(this.userRoles, requiredRoles).length
    }
    render(props) {

        const {children, requiredPermissions, requiredRoles, renderOtherWise} = this.props;
        const newChildren = Preact.cloneElement(children,
           props.matches
        )

        if (!children || (!requiredPermissions && !requiredRoles)) {
            return <>Paramètrage invalide</>;
        }
        if (requiredRoles?.length > 0){
            if (this.checkRoles()) {
                return newChildren
            }
            return renderOtherWise || null
        }

        if(this.checkPermissions()) {
            return newChildren
        }
        return renderOtherWise || null

    }
}